import RoomSelectViewLandscape from "../../views/RoomSelectViewLandscape";
import TypeSelectViewLandscape from "../../views/TypeSelectViewLandscape";
import MainViewLandscape from "../../views/MainViewLandscape";


class GameFactoryLandscape
{
    getRoomSelectView()
    {
        return RoomSelectViewLandscape;
    }

    getTypeSelectView()
    {
        return TypeSelectViewLandscape;
    }

    getMainView()
    {
        return MainViewLandscape;
    }

    getPaytable()
    {

    }
}

export default GameFactoryLandscape;